export enum SettingsTab {
  CompanyDetails = 'companyDetails',
  Members = 'members',
  MyInformation = 'myInformation',
  Preferences = 'preferences',
  Sites = 'sites',
}
